<template>
  <BuildingPage title="新建报告" description="使用步骤条表达报告生产流，后续可逐步接入模板、材料上传、内容生成和审核提交接口。">
    <el-card shadow="never" class="page-card report-create">
      <el-steps :active="activeStep" align-center finish-status="success">
        <el-step title="基础信息"></el-step>
        <el-step title="选择模板"></el-step>
        <el-step title="上传材料"></el-step>
        <el-step title="内容确认"></el-step>
        <el-step title="提交审核"></el-step>
      </el-steps>

      <el-form ref="formRef" :model="formData" :rules="rules" label-width="100px" class="report-create__form">
        <el-form-item label="报告名称" prop="reportName">
          <el-input v-model.trim="formData.reportName" placeholder="请输入报告名称"></el-input>
        </el-form-item>
        <el-form-item label="报告类型" prop="reportType">
          <el-select v-model="formData.reportType" placeholder="请选择报告类型">
            <el-option label="经营分析" value="经营分析"></el-option>
            <el-option label="项目复盘" value="项目复盘"></el-option>
            <el-option label="服务质量" value="服务质量"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人" prop="ownerName">
          <el-input v-model.trim="formData.ownerName" placeholder="请选择或输入负责人"></el-input>
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model.trim="formData.remark" type="textarea" :rows="4" placeholder="请输入报告背景、用途或注意事项"></el-input>
        </el-form-item>
        <el-form-item label="材料附件">
          <aj-upload
            multiple
            :limit="10"
            :history-files="formData.materials"
            accept-type=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar,.png,.jpg,.jpeg"
            :max-file-size="50 * 1024 * 1024"
            :upload-request="uploadToCos"
            upload-btn-text="选择报告材料"
            @upload-success="handleMaterialUploadSuccess"
          />
        </el-form-item>
      </el-form>

      <div class="report-create__footer">
        <el-button @click="goBack">返回列表</el-button>
        <el-button @click="saveDraft">保存草稿</el-button>
        <el-button type="primary" @click="submitAudit">提交审核</el-button>
      </div>
    </el-card>
  </BuildingPage>
</template>

<script>
import { addReport } from '@/api/report'
import { uploadToCos } from '@/utils/cosUpload'
import AjUpload from '@/components/ajUpload/ajUpload.vue'
import BuildingPage from '@/views/report/building/building.vue'

export default {
  name: 'ReportCreatePage',
  components: {
    AjUpload,
    BuildingPage
  },
  data () {
    return {
      activeStep: 2,
      uploadToCos,
      formData: {
        reportName: '',
        reportType: '',
        ownerName: '',
        remark: '',
        materials: [],
        status: '草稿'
      },
      rules: {
        reportName: [{ required: true, message: '请输入报告名称', trigger: 'blur' }],
        reportType: [{ required: true, message: '请选择报告类型', trigger: 'change' }],
        ownerName: [{ required: true, message: '请输入负责人', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleMaterialUploadSuccess (files) {
      this.formData.materials = files
    },
    goBack () {
      this.$router.push('/report/list')
    },
    saveDraft () {
      this.persistReport('草稿')
    },
    submitAudit () {
      this.persistReport('审核中')
    },
    persistReport (status) {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        const payload = {
          ...this.formData,
          status,
          materials: this.formData.materials.map(file => ({
            id: file.id,
            name: file.name,
            url: file.url,
            size: file.size,
            extension: file.extension,
            mime_type: file.mime_type,
            type: file.type,
            storageKey: file.storageKey
          }))
        }
        try {
          await addReport(payload)
          this.$message.success(status === '草稿' ? '草稿保存成功' : '提交审核成功')
          this.goBack()
        } catch (error) {
          this.$message.warning('后端新增接口暂未确认，当前已完成表单与上传材料收集')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.report-create {
  padding: 8px 0 24px;
}

.report-create__form {
  max-width: 760px;
  margin: 36px auto 0;
}

.report-create__footer {
  max-width: 760px;
  margin: 24px auto 0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
